import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const HorizontalLineIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf108'}</MuiIcon>
    );
}